import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="3 33 66 29"
  return (
    <path
      fill={color}
      d="M68.2 46.6 63 41.3c2.3-2.3 3.7-4.3 4.3-5.1.6-.9.4-2.1-.5-2.7-.9-.6-2.1-.4-2.7.5C62.4 36.5 53 49 36 49S9.6 36.5 7.8 34c-.6-.9-1.8-1.1-2.7-.5-.9.6-1.1 1.8-.5 2.7.6.9 2.1 2.8 4.4 5.1l-5.1 5.3c-.8.8-.8 2.1 0 2.8.4.4.9.6 1.4.6.5 0 1-.2 1.4-.6l5.2-5.4c2.2 1.9 5 3.7 8.2 5.3l-2.8 6c-.5 1 0 2.2.9 2.7.3.1.6.2.9.2.7 0 1.5-.4 1.8-1.1l2.9-6.2c3 1.1 6.4 1.8 10.2 2v6.8c0 1.1.9 2 2 2s2-.9 2-2v-6.8c3.7-.2 7.1-.9 10.1-2l2.9 6.2c.3.7 1.1 1.1 1.8 1.1.3 0 .6-.1.9-.2a2 2 0 0 0 .9-2.7l-2.8-6c3.2-1.5 6-3.4 8.2-5.3l5.2 5.4c.4.4.9.6 1.4.6.5 0 1-.2 1.4-.6.9-.8.9-2 .2-2.8z"
    />
  );
}
